export default {
  title: 'Neu in Qmulus',
  titleWithVersion: 'Neuerungen in Version {version}',
  doNotShowAfterUpdates: 'Für künftige Updates nicht mehr anzeigen',
  showAllReleases: 'Alle Neuerungen anzeigen',
};
